export const ORIENTATION = {
  landscape: 'landscape',
  portrait: 'portrait',
};

export const SIZE_CHART_COL_TYPES = {
  CONVERSION: 'CONVERSION',
  MEASUREMENT: 'MEASUREMENT',
  RETAIL_SIZE: 'RETAIL_SIZE',
};
